import { FormControl, InputLabel, MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface SelectProp {
  placeholder?: string;
  value?: string;
  data: any[],
  minWidth?: number;
  styles?: any;
  handleChange: (event: SelectChangeEvent, newVal: any) => void;
}

const SelectControl = ({
  placeholder,
  value = '',
  data = [],
  minWidth = 120,
  styles = '',
  handleChange,
  ...props
}: SelectProp | any) => {
  return (
    <FormControl sx={{ minWidth, ...styles }}>
      {placeholder && <InputLabel {...props}>{placeholder}</InputLabel>}
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        {...props}
      >
        {data.map((item: any, index: number) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectControl;